import ReactMarkdown from "react-markdown";

import { Box, Text } from "@backstage/ui";
import { formatDate } from "@internal/backstage-plugin-utility-common";
import { type Message } from "@internal/plugin-askjack-common";

import styles from "./ChatMessage.module.css";

// ── Markdown renderer ──────────────────────────────────────────────────────────

const markdownComponents: React.ComponentProps<
    typeof ReactMarkdown
>["components"] = {
    p: ({ ...props }) => <p className={styles.markdownP} {...props} />,
    a: ({ ...props }) => (
        <a
            {...props}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.markdownA}
        />
    ),
    ul: ({ ...props }) => <ul className={styles.markdownList} {...props} />,
    ol: ({ ...props }) => <ol className={styles.markdownList} {...props} />,
    li: ({ ...props }) => <li className={styles.markdownLi} {...props} />,
    code: ({ ...props }) => <code className={styles.markdownCode} {...props} />,
};

// ── ChatMessage ────────────────────────────────────────────────────────────────

export interface ChatMessageProps {
    msg: Message;
}

export const ChatMessage = ({ msg }: ChatMessageProps) => {
    const isUser = msg.role === "user";

    return (
        <Box
            mb="1"
            className={isUser ? styles.messageRight : styles.messageLeft}
        >
            <div
                className={`${styles.bubble} ${
                    isUser ? styles.bubbleUser : styles.bubbleBot
                }`}
            >
                <ReactMarkdown components={markdownComponents}>
                    {msg.text}
                </ReactMarkdown>
            </div>
            <Text
                as="div"
                variant="body-x-small"
                color="secondary"
                className={styles.timestamp}
            >
                {formatDate(msg.timestamp)}
            </Text>
        </Box>
    );
};
